import { useTranslation } from '@mypoz/i18n';
import { EmptyState } from '@mypoz/ui';

import { PageTitle } from '@/components/ui.js';
import type { AccountMenuItem, NavChild } from '@/shell/navigation.js';

/**
 * Stands in for a sidebar page that exists in the old system but has not been built here yet.
 * Routes are generated from NAV, so every menu entry lands somewhere real instead of NotFound.
 */
export function Placeholder({ titleKey }: { titleKey: NavChild['key'] | AccountMenuItem['key'] }) {
  const { t } = useTranslation();
  const { t: tNav } = useTranslation('nav');

  return (
    <>
      <PageTitle title={tNav(titleKey)} />
      <EmptyState
        icon="construction"
        title={t('placeholder.title')}
        description={t('placeholder.body')}
      />
    </>
  );
}
